import { Component, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { CurrencyInfo } from '@app/models/currency-info';
import { ButtonComponent } from '@app/components/button/button.component';
import { DialogBase } from '@app/components/dialog/dialog-base';
import { GameCurrencyPipe } from '@app/pipes/game-currency.pipe';
import { PlayerBalance } from '@app/models/player-balance';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';

export interface TournamentDialogAskPlayerRegisterToNextData {
  playerBalance: PlayerBalance;
  entryFee: number;
  houseFee: number;
  currency: CurrencyInfo

}

@Component({
  selector: 'app-tournament-dialog-ask-player-register-to-next',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    GameCurrencyPipe,
    AngularSvgIconModule,
    TranslateModule
  ],
  templateUrl: './tournament-dialog-ask-player-register-to-next.component.html',
  styleUrl: './tournament-dialog-ask-player-register-to-next.component.scss',
  host: { class: 'dialog app-tournament-dialog-ask-player-register-to-next' },
  encapsulation: ViewEncapsulation.None
})
export class TournamentDialogAskPlayerRegisterToNextComponent extends DialogBase {
  dialogData = inject<TournamentDialogAskPlayerRegisterToNextData>(DIALOG_DATA)

  buy() {
    this.dialogRef.close(true);
  }
}
